import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { AddDeviceFormType } from "@/apps/partner/types";
import { Button } from "@/components/Interface/Button/Button";

const MIN_QUANTITY = 1;
const MAX_QUANTITY = 10;

export const PlanQuantitySelector = () => {
  const { t } = useTranslation("partnerPortal", { keyPrefix: "addDevice" });
  const { watch, setValue } = useFormContext<AddDeviceFormType>();
  const quantity = watch("quantity") ?? MIN_QUANTITY;

  const decrement = () => {
    setValue("quantity", Math.max(MIN_QUANTITY, quantity - 1), {
      shouldDirty: true,
    });
  };

  const increment = () => {
    setValue("quantity", Math.min(MAX_QUANTITY, quantity + 1), {
      shouldDirty: true,
    });
  };

  return (
    <div className="flex items-center gap-4">
      <Button
        dataTestid="plan-quantity-decrement"
        type="button"
        variant="secondary"
        onClick={decrement}
        disabled={quantity <= MIN_QUANTITY}
        ariaLabel={t("quantity.decrement")}
      >
        −
      </Button>
      <span
        data-testid="plan-quantity-value"
        className="min-w-8 text-center text-body-lg font-semibold text-foreground-primary"
      >
        {quantity}
      </span>
      <Button
        dataTestid="plan-quantity-increment"
        type="button"
        variant="secondary"
        onClick={increment}
        disabled={quantity >= MAX_QUANTITY}
        ariaLabel={t("quantity.increment")}
      >
        +
      </Button>
    </div>
  );
};
